import * as React from 'react'
import { DeleteTaskButtonConnected } from './DeleteTaskButtonConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DeleteTaskButtonExamples = () => {
  return (
    <div className="DeleteTaskButtonExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DeleteTaskButtonConnected />
      </Provider>
    </div>
  )
}
